import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Profile } from './profile';
export { Profile };
import { profileSchema } from '@schemas/business-objects/profile';
import { UserFormGroup } from './user-form-group';

export class ProfileFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    fullName: SchemaFormControl;
    alias: SchemaFormControl;
    userId: SchemaFormControl;
    user: UserFormGroup;
  };

  declare value: Partial<Profile>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(profileSchema, Profile, data, options);
  }

  get object(): Profile {
    return new Profile(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'user':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Profile[]> {
    return Profile.find(filter);
  }

  static async findOne(filter?: any): Promise<Profile | null> {
    return Profile.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Profile> {
    return Profile.findById(id, filter);
  }

  static async create(data: Partial<Profile>): Promise<Profile> {
    return Profile.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<Profile>,
  ): Promise<Profile> {
    return Profile.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Profile.deleteById(id);
  }

  static async currentUserProfile(filter: any): Promise<any> {
    return Profile.currentUserProfile(filter);
  }
}

export class ProfileFormArray extends PersistedFormArray {
  declare controls: ProfileFormGroup[];

  readonly entityName = 'Profile' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(profileSchema, Profile, options);
  }

  protected override createItemGroup() {
    return new ProfileFormGroup();
  }

  get array(): Profile[] {
    return this.controls.map((group: ProfileFormGroup) => group.object);
  }
}

export class ProfilePersistedArray extends PersistedArray<Profile> {
  readonly entityName = 'Profile' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Profile, options);
  }
}
